import * as React from 'react';
const defaultContext = {
    LinkComponent: 'a',
};
const DesignSystemContext = React.createContext(defaultContext);
export const useDesignSystem = () => React.useContext(DesignSystemContext);
export const DesignSystemProvider = ({ children, LinkComponent, }) => {
    return children ? (React.createElement(DesignSystemContext.Provider, { value: {
            LinkComponent,
        } }, React.Children.only(children))) : null;
};
//# sourceMappingURL=DesignSystemProvider.js.map
// @zapier/design-system-context@1.4.0 (cea05a1c8)
